// extracted by mini-css-extract-plugin
export default {"container":"ZABKX8v4dxyLv6bfbPDw","title":"F4uJLKRbt3GBeGhy4NM2"};